module.exports = __webpack_public_path__ + "images/patterns/dark/GrooveDiagonal.86b0f00c2934164795ad.svg";